import React from 'react'

// GraphQL
import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      setPaymentProfileForm, // from redux actions
      setPaymentMethod, // from redux actions
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted // via withQueryResults
    } = props

    // return true if account has a saved Stripe payment profile
    const isStripe = paymentProfile =>
      paymentProfile && paymentProfile.type === 'StripePaymentProfile'

    // react hooks
    const { loading, data } = useQuery(query, {
      onCompleted: data => {
        if (!onLoggedInQueryCompleted(data)) {
          return
        }

        const { viewer: account } = data
        const { paymentProfile, user } = account

        setPaymentProfileForm(paymentProfile || Object.assign({}, user))
        setPaymentMethod(isStripe(paymentProfile) ? 'saved' : 'bank')
      },
      onError: onQueryError
    })

    // GraphQL data
    const {
      viewer: account,
      countries,
      states,
      seasons,
      customerSessionClientSecret
    } = data || {}

    const season = seasons ? seasons[0] : {}
    const cartTotalCents = account?.cart?.totalCents

    return (
      <WrappedComponent
        loading={loading}
        account={account}
        countries={countries || []}
        states={states || []}
        season={season}
        customerSessionClientSecret={customerSessionClientSecret}
        cartTotalCents={cartTotalCents}
        {...props}
      />
    )
  }
}

export default withQuery
